import { type NavMenuHierarchyL2 } from '../../nav-v2/NavMenuHierarchy'

interface PermissionCheckboxProps {
  tool: NavMenuHierarchyL2
  selectedPermissionSlugs: Set<string>
  toolRequiredPermissionSet: Set<string>
  toolHardEnabled: boolean
  handlePermissionSlugsChange: (newSelectedPermissionSlugs: Set<string>) => void
}

export const getPermissionCheckboxProps = ({
  tool,
  selectedPermissionSlugs,
  toolRequiredPermissionSet,
  toolHardEnabled,
  handlePermissionSlugsChange,
}: PermissionCheckboxProps) => {
  const isChecked =
    selectedPermissionSlugs.isSupersetOf(toolRequiredPermissionSet) || toolHardEnabled
  const isDisabled = toolRequiredPermissionSet.size === 0 || toolHardEnabled

  const onCheckboxChange = () => {
    const difference = toolRequiredPermissionSet.difference(selectedPermissionSlugs)

    if (difference.size > 0) {
      // was not selected, add it
      handlePermissionSlugsChange(
        toolRequiredPermissionSet
          .union(selectedPermissionSlugs)
          .union(new Set(tool.inToolPermissions?.map(p => p.slug) || []))
      )
    } else {
      // was selected, remove it
      handlePermissionSlugsChange(
        selectedPermissionSlugs
          .difference(toolRequiredPermissionSet)
          .difference(new Set(tool.inToolPermissions?.map(p => p.slug) || []))
      )
    }
  }

  return {
    isChecked,
    isDisabled,
    onCheckboxChange,
  }
}
